export const SET_ORDER_INFO = 'SET_ORDER_INFO'

export const SET_PARKINGLOTID = 'SET_PARKINGLOTID'

export const SET_OPENID = 'SET_OPENID'

export const SET_BUYID = 'SET_BUYID'

export const SET_DOORID = 'SET_DOORID'

export const SET_CURRENT_PATH = 'SET_CURRENT_PATH'

export const SET_PARKREC = 'SET_PARKREC'

export const SET_PARKING_INFO = 'SET_PARKING_INFO'

export const SET_COUPONFEE = 'SET_COUPONFEE'

export const SET_LAST_PLATENO = 'SET_LAST_PLATENO'

export const SET_AREA_ID = "SET_AREA_ID"

export const SET_CHECKED_PARKINGLOT_ID = "SET_CHECKED_PARKINGLOT_ID"

export const SET_USER_PHONE = "SET_USER_PHONE"

export const SET_USER_OPENID = "SET_USER_OPENID"

export const SET_BUSINESS_IDS = "SET_BUSINESS_IDS"

export const SET_TASK_ID = "SET_TASK_ID"

export const SET_ORDERSN = "SET_ORDERSN"

export const SET_RESULT_ORDERSN = "SET_RESULT_ORDERSN"

export const SET_RECEIPT_ORDERSN_OBJ = "SET_RECEIPT_ORDERSN_OBJ"

export const SET_TOTAL_PRICE = "SET_TOTAL_PRICE"

export const SET_ISNOTIFICATION = "SET_ISNOTIFICATION"

export const SET_KEYTOPORDERNO = "SET_KEYTOPORDERNO"

export const SET_PARKRECID = "SET_PARKRECID"

export const SET_CLICKMERRECORD = "SET_CLICKMERRECORD"

export const SET_INTERFACEMANNER = "SET_INTERFACEMANNER"

export const SET_KEYTOPINIMGURL = "SET_KEYTOPINIMGURL"

export const SET_ISCARDPAY = "SET_ISCARDPAY"

export const SET_RECEPITINFO = "SET_RECEPITINFO"

export const SET_ORDERSNLIST = "SET_ORDERSNLIST"

export const SET_RECEIPT_PARKINGLOTID = "SET_RECEIPT_PARKINGLOTID"

export const SET_ABPARKID = "SET_ABPARKID"

export const SET_ABSHOW = "SET_ABSHOW"

export const SET_OPENAD = "SET_OPENAD"
